import React from 'react';

export default function SampleTag({ children = 'Example' }) {
    return <span className='lp-sample'>{children}</span>;
}
